import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getOrganisationNameByAppNumber } from '../config/appsConfig';

// Migration partenaire : 10 mars 2026, 00h00-06h00 (heure Paris)
const MIGRATION_END = new Date('2026-03-10T06:00:00+01:00');
const isMigrationPeriod = () => new Date() < MIGRATION_END;

export const applyHeroHoverStyles = (isHero, appNumber, target, isHover) => {
    if (!isHero || appNumber !== 4 || !target) {
        return;
    }
    target.style.background = isHover ? '#007bff' : 'white';
    target.style.color = isHover ? 'white' : '#007bff';
};

const AutoRedirect = ({ redirectUrl, isHero = false, appNumber }) => {
    const apiPrefix = process.env.REACT_APP_API_PREFIX;
    const Numberapp = useSelector((state) => state.app.appNumber) || appNumber;
    const [error, setError] = useState(null);
    const [showMigrationModal, setShowMigrationModal] = useState(false);
    const userId = useSelector((state) => state.user.user.user.id);
    const sessionToken = useSelector((state) => state.user.token);

    const fetchToken = async () => {
        try {
            if (!Numberapp) {
                throw new Error('Invalid application number');
            }
            const response = await fetch(`${apiPrefix}autologin/token/${userId}?appNumber=${Numberapp}`, { 
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${sessionToken}`,
                }
            });
            if (!response.ok) {
                throw new Error('Failed to fetch token');
            }
            const data = await response.json();
            return data.token;
        } catch (error) {
            setError(error.message);
            return null;
        }
    };

    const performRedirect = async () => {
        try {
            const token = await fetchToken();
            if (token) {
                const organisationName = getOrganisationNameByAppNumber(Numberapp) || 'MES-BONS-PLANS-KLESIA-PRO';

                const redirectLink = redirectUrl.includes('app.reducce.fr') && organisationName
                    ? `${redirectUrl}${token}?organisation=${organisationName}`
                    : `${redirectUrl}${token}`;
                window.open(redirectLink, '_blank');
            }
        } catch (err) {
            setError(err.message);
        }
    };

    const handleClick = () => {
        if (isMigrationPeriod()) {
            setShowMigrationModal(true);
        } else {
            performRedirect();
        }
    };

    const handleConfirmMigration = () => {
        setShowMigrationModal(false);
        performRedirect();
    };

    return (
        <div className="text-center">
            {error && (
                <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">
                    <i className="fas fa-exclamation-triangle mr-2"></i>
                    {error}
                </div>
            )}
            <button 
                className={isHero 
                    ? "bg-white/90 backdrop-blur-sm text-theme-primary hover:bg-white hover:text-theme-primary-active text-lg px-8 py-4 rounded-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 active:translate-y-0 active:shadow-md"
                    : "btn-modern w-full"
                }
                style={isHero && Numberapp === 4 ? {
                    background: 'white',
                    color: '#007bff',
                    border: '2px solid #007bff',
                    borderRadius: '8px'
                } : {}}
                onMouseEnter={(e) => applyHeroHoverStyles(isHero, Numberapp, e.target, true)}
                onMouseLeave={(e) => applyHeroHoverStyles(isHero, Numberapp, e.target, false)}
                onClick={handleClick}
            >
                <i className="fas fa-rocket mr-2"></i>
                Je découvre !
            </button>

            {showMigrationModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="card-theme max-w-md w-full text-center relative">
                        <button
                            onClick={() => setShowMigrationModal(false)}
                            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold"
                        >
                            &times;
                        </button>
                        <div className="mb-6">
                            <i className="fas fa-tools text-4xl text-amber-500 mb-4"></i>
                            <h2 className="text-xl font-bold text-theme-primary mb-4">
                                Maintenance prévue
                            </h2>
                            <p className="text-gray-600 text-sm">
                                Le site partenaire effectue une migration majeure le <strong>mardi 10 mars 2026</strong> de <strong>00h00 à 06h00</strong>.
                            </p>
                            <p className="text-gray-600 text-sm mt-2">
                                En raison de cette maintenance, certains éléments peuvent être temporairement indisponibles.
                            </p>
                            <p className="text-gray-600 text-sm mt-2">
                                Souhaitez-vous continuer ?
                            </p>
                        </div>
                        <button
                            onClick={handleConfirmMigration}
                            className="btn-theme"
                        >
                            <i className="fas fa-rocket mr-2"></i>
                            Continuer
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AutoRedirect;
